// import components
import DateNavigation from 'components/shared/DateNavigation';
import { useDateNavigationStore } from 'components/shared/DateNavigation/DateNavigation.stores';

// import hooks
import { useState } from 'react';

// import utils
import dayjs from 'dayjs';
import { getMonthInterval, getWeekInterval } from 'utils/date';

// import types
import type { SingleOrRange } from 'components/shared/DateNavigation/DateNavigation.types';
import type { PeriodSelectorProps } from '../Servicedesk.types';

const PeriodSelector = ({ onChange }: PeriodSelectorProps) => {
  const [defaultDate, setDefaultDate] = useState<Date | null>(null);
  const [defaultDateRange, setDefaultDateRange] = useState<
    [Date | null, Date | null] | null
  >(null);
  const period = useDateNavigationStore((state) => state.period) ?? 'month';

  const handleDateChange = (value: SingleOrRange | null) => {
    if (Array.isArray(value)) {
      const [start, end] = value;
      const range: [Date | null, Date | null] = [
        start ? dayjs(start).toDate() : null,
        end ? dayjs(end).toDate() : null
      ];
      setDefaultDateRange(range);
      onChange(range);
      return;
    }

    if (!value) {
      setDefaultDate(null);
      onChange([null, null]);
      return;
    }

    const date = dayjs(value).toDate();
    setDefaultDate(date);

    const { startDate, endDate } =
      period === 'week' ? getWeekInterval(date) : getMonthInterval(date);
    onChange([startDate, endDate]);
  };

  return (
    <DateNavigation
      defaultPeriod="month"
      defaultDate={defaultDate}
      defaultDateRange={defaultDateRange}
      onDateChange={handleDateChange}
      options={['week', 'month', 'custom']}
      allowMenuOptions
    />
  );
};

export default PeriodSelector;
